import { render } from "./Garaje.vue?vue&type=template&id=63803160&scoped=true"
import script from "./Garaje.vue?vue&type=script&lang=js"
export * from "./Garaje.vue?vue&type=script&lang=js"

import "./Garaje.vue?vue&type=style&index=0&id=63803160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63803160"]])

export default __exports__